import { render, staticRenderFns } from "./cardList.vue?vue&type=template&id=1a41141d&scoped=true&"
import script from "./cardList.vue?vue&type=script&lang=js&"
export * from "./cardList.vue?vue&type=script&lang=js&"
import style0 from "./cardList.vue?vue&type=style&index=0&id=1a41141d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a41141d",
  null
  
)

export default component.exports